import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { vendorSchema } from "../validations";
import * as Components from "../../../components";
import {
  useCreateVendorMutation,
  useGetVendorQuery,
  useUpdateVendorMutation,
} from "../../ManagementPortal/services";
import { FormContainer } from "../../ManagementPortal/Shared/FormContainer";
import { mergeObjects } from "../../../shared/helper";
import { useForm } from "../../../hooks";

export const VendorForm = ({ idToEdit = null, closeForm }) => {
  const [initialValues, setInitialValues] = useState({
    vendor_name: "",
    tag_name: "",
  });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: vendorSchema,
    onSubmit: (values) => handleFormSubmit(values),
  });

  const { create: createVendor, update: updateVendor } = useForm({
    createMutation: useCreateVendorMutation,
    updateMutation: useUpdateVendorMutation,
    closeForm,
    setError: formik.setErrors,
  });

  const { data } = useGetVendorQuery({ id: idToEdit }, { skip: !idToEdit });

  // Set form data in case of edit
  useEffect(() => {
    if (idToEdit && data) {
      setInitialValues(mergeObjects(formik.initialValues, data));
    }
  }, [data]);

  const handleFormSubmit = (formData) => {
    if (idToEdit) {
      updateVendor({ formData, id: idToEdit });
    } else {
      createVendor({ formData });
    }
  };

  return (
    <FormContainer
      resourceName="Vendor"
      closeForm={closeForm}
      idToEdit={idToEdit}
      handleFormSubmit={formik.handleSubmit}
    >
      <Components.QIInput
        label="Name"
        placeholder="Vendor Name"
        {...formik.getFieldProps("vendor_name")}
        error={formik.touched.vendor_name && formik.errors.vendor_name}
      />

      <Components.QIInput
        label="Tag Name"
        placeholder="Tag Name"
        {...formik.getFieldProps("tag_name")}
        error={formik.touched.tag_name && formik.errors.tag_name}
      />
    </FormContainer>
  );
};
